import { styles } from './template.scss';

export const templateAlertsApp = document.createElement('template');

templateAlertsApp.innerHTML = `
  <style>${styles}</style>

  <div class="wrapper" />
`;
